// extracted by mini-css-extract-plugin
export default {"divider":"AdditionalListWidget_divider__tgra8","container":"AdditionalListWidget_container__uKKTq"};